//
import competitionHomeRutes from './compeitionHome.js'

import state from '../store/user/state.js'

import Home from '../views/home/Home.vue'
import HomeNavigation from '../views/home/HomeNavigation.vue'

const homeRutes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: (to, from) => {
      const isAuthenticated = state.isLoggedIn
      // reject the navigation
      if ((isAuthenticated)&&(to.name === 'home')) {
        return { path: '/ds' }
      } else {
        return true
      }
    },
  },
  {
    path: '/home',
    component: HomeNavigation,
    children: [
      {
        path: '/fixture/generar',
        name: 'fixture-creator',
        component: () => import('../views/home/FixtureCreatorHomePage.vue')
      },
      {
        path: '/registro-jugador-torneo/:codUrl',
        name: 'public-player-register',
        component: () => import('../views/competition/DeportistaPublicFormRegisterPage.vue')
      },
      {
        path: '/torneo/:idTorneo',
        component: () => import('../views/home/TorneoHomeNavigation.vue'),
        children: [
          {
            path: '',
            name: 'home-detalle-torneo',
            component: () => import('../views/home/DetailTorneoHome.vue'),
          },
          {
            path: 'news',
            name: 'home-news-torneo',
            component: () => import('../views/home/NewsTorneoHome.vue'),
          },
          {
            path: 'fixture',
            name: 'home-fixture-torneo',
            component: () => import('../views/home/FixtureTorneoHome.vue'),
          },
          {
            path: 'equipos',
            name: 'home-equipos-torneo',
            component: () => import('../views/home/TeamsTorneoHome.vue'),
          },
          {
            path: 'resultados',
            name: 'home-resultados-torneo',
            component: () => import('../views/home/ResultsTorneoHome.vue'),
          },
          {
            path: 'tabla',
            name: 'home-tabla-torneo',
            component: () => import('../views/home/TablaTorneoHome.vue'),
          },
          {
            path: 'estadisticas',
            component: () => import('../views/home/EstadisticasTorneoHome.vue'),
            children: [
              {
                path: 'goles',
                name: 'home-goleadores-torneo',
                component: () => import('../views/home/GoleadoresTorneoHome.vue'),
              },
              {
                path: 'amarillas',
                name: 'home-amarillas-torneo',
                component: () => import('../views/home/AmarillasTorneoHome.vue'),
              },
              {
                path: 'rojas',
                name: 'home-rojas-torneo',
                component: () => import('../views/home/RojasTorneoHome.vue'),
              },
            ]
          },
        ]
      },
      {
        path: 'search',
        component: () => import('../views/search/ResultadosBusqueda.vue'),
        children: [
          {
            path: 'todo',
            name: 'home-resultados-busqueda',
            component: () => import('../views/search/ResultsTodoSearch.vue'),
          },
          {
            path: 'torneos',
            name: 'home-resultados-busqueda-torneo',
            component: () => import('../views/search/ResultsTorneoSearch.vue'),
          },
          {
            path: 'equipos',
            name: 'home-resultados-busqueda-equipo',
            component: () => import('../views/search/ResultsEquipoSearch.vue'),
          },
          {
            path: 'jugadores',
            name: 'home-resultados-busqueda-jugador',
            component: () => import('../views/search/ResultsJugadorSearch.vue'),
          },
        ]
      },
    ].concat(competitionHomeRutes)
  },
  {
    path: '/:catchAll(.*)', 
    component: () => import('../views/home/Error404Page.vue'),
    name: 'NotFound'
  }
]

export default homeRutes;